import Clivia1 from '../Clivia/Clivia (1).webp'
import Clivia2 from '../Clivia/Clivia (3).webp'
import Clivia3 from '../Clivia/Clivia (4).webp'
import Clivia4 from '../Clivia/Clivia (5).webp'
import Clivia5 from '../Clivia/Clivia (6).webp'


const Cliviaimages =[
Clivia1,Clivia2,Clivia3,Clivia4,Clivia5
]

export default Cliviaimages;